import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Loader2, AlertCircle, ArrowRight } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PayPalSubscriptionSuccessPage() {
  const [params] = useSearchParams();
  const subId = params.get('subscription_id');
  const [state, setState] = useState({ loading: true, ok: false, error: '', kind: '', tierLabel: '' });

  useEffect(() => {
    if (!subId) {
      setState({ loading: false, ok: false, error: 'Falta subscription_id', kind: '', tierLabel: '' });
      return;
    }
    (async () => {
      try {
        const r = await axios.post(`${API_URL}/api/paypal-subscriptions/activate`,
          { subscription_id: subId }, { withCredentials: true });
        setState({
          loading: false,
          ok: true,
          error: '',
          kind: r.data?.kind || '',
          tierLabel: r.data?.tier_label || '',
        });
      } catch (e) {
        setState({ loading: false, ok: false, error: e?.response?.data?.detail || 'Error', kind: '', tierLabel: '' });
      }
    })();
  }, [subId]);

  const isMembership = state.kind === 'membership';
  const overline = isMembership ? `${state.tierLabel} · Activa` : 'Mensual Ilimitado · Activa';
  const title = isMembership ? `¡Bienvenido a ${state.tierLabel}!` : '¡Bienvenido al Mensual!';
  const desc = isMembership
    ? 'Tu membresía está activa. Renovación automática mensual — cancela cuando quieras.'
    : 'Los 8 presets OG están desbloqueados durante todo el mes en tu cuota diaria.';
  const ctaHref = isMembership ? '/catalog' : '/mastering-og';
  const ctaLabel = isMembership ? 'Explorar catálogo' : 'Empezar a masterizar';

  return (
    <div className="min-h-screen pt-32 pb-20 flex items-center justify-center">
      <div className="container-custom max-w-xl">
        <div className="glass-card p-10 text-center" data-testid="sub-success-card">
          {state.loading && (
            <>
              <Loader2 className="w-12 h-12 text-[#E8720C] mx-auto mb-4 animate-spin" />
              <p className="text-white/70">Activando tu suscripción…</p>
            </>
          )}
          {!state.loading && state.ok && (
            <>
              <CheckCircle className="w-14 h-14 text-green-400 mx-auto mb-5" />
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#E8720C] font-bold mb-2">{overline}</p>
              <h1 className="text-3xl font-bold mb-3">{title}</h1>
              <p className="text-white/60 mb-8">{desc}</p>
              <Link to={ctaHref} className="inline-flex items-center gap-2 px-8 py-3 bg-[#E8720C] hover:bg-[#C55A00] rounded-full font-bold text-sm" data-testid="sub-success-cta">
                {ctaLabel} <ArrowRight className="w-4 h-4" />
              </Link>
            </>
          )}
          {!state.loading && !state.ok && (
            <>
              <AlertCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
              <h1 className="text-2xl font-bold mb-2">No pudimos activar tu suscripción</h1>
              <p className="text-sm text-white/60 mb-6">{state.error}</p>
              <Link to="/membership" className="inline-flex items-center gap-2 px-6 py-2.5 bg-white/5 border border-white/10 rounded-full font-bold text-sm">
                Volver
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
